// ink-component
import React, { ReactNode } from 'react';
import Box from '../../../Box/Box';
import HStack, { HStackProps } from '../../../HStack/HStack';

export interface ActionsProps extends HStackProps {
  /** Element that should be outlined */
  children: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose Actions wrapper component for Ledger implementations
 * @categories table
 * @group ledger
 */
const Actions = (props: ActionsProps) => {
  const { children, ...otherProps } = props;
  return (
    <Box bottom="gutter">
      <HStack spacing="medium" {...otherProps}>
        {children}
      </HStack>
    </Box>
  );
};

Actions.displayName = 'LedgerWrapper.Actions';

Actions.defaultProps = {
  'data-testid': undefined,
};

export default Actions;
